/* eslint-disable max-len */
import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
import { ContinueButton } from '@bookingForm/styles/buttons';
import { Actions } from '@widgets/GenericBookings/components/AttendeesSelector/styles';
export const Wrapper = styled.div `
  ${Actions} {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  ${ContinueButton} {
    max-width: 40rem;
  }

  ${ContinueButton}:disabled {
    margin-top: 2rem;
  }
  
  ${ContinueButton}:not(:disabled) {
    background-color: var(--secondary-btn);
    border-color: var(--secondary-btn);
    margin-top: 2rem;
    &:hover {
      background-color: var(--secondary-btn-hover);
      border-color: var(--secondary-btn-hover);
    }
  }
`;
export const Title = styled.span `
  font: var(--heading-three-font);
  text-align: center;
  width: 100%;
  display: block;
  color: var(--primary-darker);
  margin-bottom: 2rem;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    font: var(--heading-two-font);
    margin-bottom: 1.5rem;
    text-align: left;
  }
`;
export const NonSelectedWrapper = styled.div `
`;
export const SelectedWrapper = styled.div `
  & + ${NonSelectedWrapper} {
    margin-top: 3rem;
  }
`;
export const List = styled.ul `
 list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0;
  margin: 0;
  
  li {
    padding: 0;
    margin: 0;
  }
`;
export const CardContainer = styled.label `
  display: block;
  box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  width: 100%;
  max-width: 60.6rem;
  background-color: white;
  border: 0.2rem solid white;
  margin: 0 auto;
  border-radius: var(--border-radius-sm);
  user-select: none;
`;
export const Card = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% + 0.4rem);
  min-height: 23.5rem;
  margin: -0.2rem;
  overflow: hidden;
  border-radius: var(--border-radius-sm);
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    flex-direction: column;
    border-radius: var(--border-radius-md);
    
  }
`;
export const CardPicture = styled.picture `
  position: relative;
  line-height: 0;
  display: block;
  flex: 18.3rem;
  align-self: stretch;
  margin: -0.2rem 0 -0.2rem -0.2rem;
  user-select: none;
  
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    flex: auto;
    width: calc(100% + 0.2rem);
    height: 21rem;
  }
`;
export const CardContent = styled.div `
  width: 100%;
  padding: 2rem;
  
  .tag {
    .tag__text {
      color: var(--primary-darker);
    }
  }
`;
export const CardTitle = styled.span `
  font: var(--heading-four-font);
  color: var(--primary-darker);
  display: block;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    margin-top: 0;
    font: var(--heading-two-font);
  }
`;
export const CardSubtitle = styled.span `
  font: var(--paragraph-font);
  font-weight: 600;
  margin-top: 1rem;
  color: var(--primary-darker);
  display: block;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    margin-top: 0.5rem;
  }
`;
export const CardCopy = styled.p `
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    margin-top: 1rem;
  }
`;
export const Checkbox = styled.input `
  display: none;
  
  &:checked + ${CardContainer} {
    border-color: var(--primary-medium);
    
    ${CardPicture} {
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: var(--primary-medium);
        opacity: 0.8;
      }
      
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 3rem;
        height: 3rem;
        background-color: white;
        border-radius: 50%;
        background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjMDBhZWVmOwogICAgICAgIHN0cm9rZS13aWR0aDogMHB4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04LjQsMTIuMWMtLjMsMC0uNS0uMS0uNy0uM2wtMi41LTIuNWMtLjQtLjQtLjQtMSwwLTEuNC40LS40LDEtLjQsMS40LDBsMS44LDEuOCwzLjQtMy40Yy40LS40LDEtLjQsMS40LDBzLjQsMSwwLDEuNGwtNC4xLDQuMWMtLjIuMi0uNC4zLS43LjNaIi8+Cjwvc3ZnPg==");
        background-size: 3rem 3rem;
        background-repeat: no-repeat;
        background-position: center center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;
export default {
    Wrapper,
};
